module.exports = __webpack_public_path__ + "img/548.2a78f2b8.png";